import axios from "axios";
import { APP_VERSION } from "../store/constants.js";

// export const BASE_URL = "http://localhost:5001";
export const BASE_URL = "https://mrc.potentium.rs";

const API_BASE_URL = `${BASE_URL}/api/`;
const AUTH_BASE_URL = `${BASE_URL}/auth/`;

const axiosAuthClient = axios.create({
  baseURL: AUTH_BASE_URL,
  withCredentials: true,
});

const axiosApiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Public client for unauthenticated requests
const axiosPublicClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
});

axiosAuthClient.interceptors.request.use(
  (config) => {
    config.headers = {
      version: APP_VERSION,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let store;
export const injectStore = (_store) => {
  store = _store;
};

axiosApiClient.interceptors.request.use(
  (config) => {
    const token = store.getState().authInfo.token;
    config.headers = {
      version: APP_VERSION,
    };

    // Samo dodaj Authorization header ako token postoji
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Dodaj Content-Type header za JSON requests ako nije FormData
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json; charset=utf-8";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Public client interceptor (no auth)
axiosPublicClient.interceptors.request.use(
  (config) => {
    config.headers = {
      version: APP_VERSION,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosApiClient;
export { axiosAuthClient, axiosApiClient, axiosPublicClient };
